import validate from "./validate";

export default function validateForm(form) {
  const result = {
    form: form,
    valid: true,
    errors: []
  };

  for (let field in form) {
    const valid = validate(form[field].value, form[field].validate);

    result.form[field].isError = !valid.valid;
    result.form[field].errors = valid.errors;

    if (!valid.valid) {
      result.valid = false;
      result.errors = result.errors.concat(valid.errors);
    }
  }

  return result;
}
